import type {BannerCarrosselProps } from "@/components/banner-carrossel/banner-carrossel.props"
import { ContentBanner } from "../conteudoBanner/ContentBanner"
import { BannerCarrosselMidia } from "../conteudoBanner/BannerCarrosselMidia"
import { ValorProduto } from "./ValorProduto"
import { priceFormatter } from "@/utils/formatter"
import { Device } from "@/utils/device"

interface BannerCarrosselAutomaticoProps {
    banner: BannerCarrosselProps
    width: number
    height: number
    idx: number
    isFirst: boolean
    exibeValoresSomenteLogado: boolean
    precoPrincipal: number
    condicaoParcelamento: number
    device: number
}

export function BannerCarrosselAutomatico({
    banner,
    width,
    height,
    idx,
    isFirst,
    exibeValoresSomenteLogado,
    precoPrincipal,
    condicaoParcelamento,
    device
}: Readonly<BannerCarrosselAutomaticoProps>) {
    return (
        <div className="container">
            <ContentBanner banner={banner}>
                <BannerCarrosselMidia
                    banner={banner}
                    width={width}
                    height={height}
                    idx={idx}
                    isFirst={isFirst}
                />

                <div className="conteudo-banner-automatico">
                    <div className="conteudo">
                        <div className="produto-nome">{banner.produto.produto_nome}</div>

                        <div className={`valores${(banner.valor_antigo < banner.valor_boleto) && ' not-old-price'}`}>
                            {exibeValoresSomenteLogado ? (
                                <div className="valor-produto">
                                    <div className="preco-escondido valor">
                                        R$ <span className="valor-escondido">XXX,XX</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {banner.valor_antigo > banner.valor_boleto && (
                                        <div className="valor-produto-antigo">
                                            <div className="valor-antigo">
                                                de {priceFormatter.format(banner.valor_antigo)} por
                                            </div>
                                        </div>
                                    )}

                                    <ValorProduto
                                        banner={banner}
                                        precoPrincipal={precoPrincipal}
                                        condicaoParcelamento={condicaoParcelamento}
                                        device={device}
                                    />
                                </>
                            )}
                        </div>

                        {(!exibeValoresSomenteLogado && (device !== (Device.MOBILE || Device.TABLET || Device.APP))) && (
                            <div className="ver-produto">
                                <span className="btn-ver-produto button button-default">
                                    Comprar
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </ContentBanner>
        </div>
    )
}